"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingAnchorRelativeSizeValueDestination = exports.DrawingAnchorVerticalRelativeSizeDestination = exports.DrawingAnchorHorizontalRelativeSizeDestination = exports.DrawingAnchorRelativeSizeBaseDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var enums_1 = require("../../../../core/model/floating-objects/enums");
var string_1 = require("@devexpress/utils/lib/utils/string");
var translation_tables_1 = require("../../../translation-table/translation-tables");
var destination_1 = require("../destination");
var DrawingAnchorRelativeSizeBaseDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorRelativeSizeBaseDestination, _super);
    function DrawingAnchorRelativeSizeBaseDestination(data, anchorDestination) {
        var _this = _super.call(this, data) || this;
        _this.value = 100 * 1000;
        _this.anchorDestination = anchorDestination;
        return _this;
    }
    DrawingAnchorRelativeSizeBaseDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    DrawingAnchorRelativeSizeBaseDestination.prototype.processElementClose = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.processElementCloseCore(reader);
                return [2];
            });
        });
    };
    DrawingAnchorRelativeSizeBaseDestination.prototype.processElementCloseCore = function (_reader) { throw new Error('not implemented'); };
    return DrawingAnchorRelativeSizeBaseDestination;
}(destination_1.ElementDestination));
exports.DrawingAnchorRelativeSizeBaseDestination = DrawingAnchorRelativeSizeBaseDestination;
var DrawingAnchorHorizontalRelativeSizeDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorHorizontalRelativeSizeDestination, _super);
    function DrawingAnchorHorizontalRelativeSizeDestination(data, anchorDestination) {
        return _super.call(this, data, anchorDestination) || this;
    }
    Object.defineProperty(DrawingAnchorHorizontalRelativeSizeDestination.prototype, "elementHandlerTable", {
        get: function () {
            return DrawingAnchorHorizontalRelativeSizeDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    DrawingAnchorHorizontalRelativeSizeDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    DrawingAnchorHorizontalRelativeSizeDestination.onPictureWidth = function (data, _reader) {
        return new DrawingAnchorRelativeSizeValueDestination(data, DrawingAnchorHorizontalRelativeSizeDestination.getThis(data));
    };
    DrawingAnchorHorizontalRelativeSizeDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var value;
            return tslib_1.__generator(this, function (_a) {
                value = reader.getAttribute('relativeFrom');
                this.relativeFrom = this.data.readerHelper.getWpEnumValueCore(value, translation_tables_1.TranslationTables.floatingObjectRelativeFromHorizontalTable.importMap, enums_1.RelativeWidthType.Page);
                return [2];
            });
        });
    };
    DrawingAnchorHorizontalRelativeSizeDestination.prototype.processElementCloseCore = function (_reader) {
        var obj = this.anchorDestination.floatingObjectImportInfo.size;
        obj.relativeWidthType = this.relativeFrom;
        obj.relativeSize.width = this.value;
        if (this.value > 0)
            obj.setUseAbsoluteWidth(false);
    };
    DrawingAnchorHorizontalRelativeSizeDestination.handlerTable = new map_creator_1.MapCreator()
        .add('pctWidth', DrawingAnchorHorizontalRelativeSizeDestination.onPictureWidth)
        .get();
    return DrawingAnchorHorizontalRelativeSizeDestination;
}(DrawingAnchorRelativeSizeBaseDestination));
exports.DrawingAnchorHorizontalRelativeSizeDestination = DrawingAnchorHorizontalRelativeSizeDestination;
var DrawingAnchorVerticalRelativeSizeDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorVerticalRelativeSizeDestination, _super);
    function DrawingAnchorVerticalRelativeSizeDestination(data, anchorDestination) {
        return _super.call(this, data, anchorDestination) || this;
    }
    Object.defineProperty(DrawingAnchorVerticalRelativeSizeDestination.prototype, "elementHandlerTable", {
        get: function () {
            return DrawingAnchorVerticalRelativeSizeDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    DrawingAnchorVerticalRelativeSizeDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    DrawingAnchorVerticalRelativeSizeDestination.onPictureHeight = function (data, _reader) {
        return new DrawingAnchorRelativeSizeValueDestination(data, DrawingAnchorVerticalRelativeSizeDestination.getThis(data));
    };
    DrawingAnchorVerticalRelativeSizeDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var value;
            return tslib_1.__generator(this, function (_a) {
                value = reader.getAttribute('relativeFrom');
                this.relativeFrom = this.data.readerHelper.getWpEnumValueCore(value, translation_tables_1.TranslationTables.floatingObjectRelativeFromVerticalTable.importMap, enums_1.RelativeHeightType.Page);
                return [2];
            });
        });
    };
    DrawingAnchorVerticalRelativeSizeDestination.prototype.processElementCloseCore = function (_reader) {
        var obj = this.anchorDestination.floatingObjectImportInfo.size;
        obj.relativeHeightType = this.relativeFrom;
        obj.relativeSize.height = this.value;
        if (this.value > 0)
            obj.setUseAbsoluteHeight(false);
    };
    DrawingAnchorVerticalRelativeSizeDestination.handlerTable = new map_creator_1.MapCreator()
        .add('pctHeight', DrawingAnchorVerticalRelativeSizeDestination.onPictureHeight)
        .get();
    return DrawingAnchorVerticalRelativeSizeDestination;
}(DrawingAnchorRelativeSizeBaseDestination));
exports.DrawingAnchorVerticalRelativeSizeDestination = DrawingAnchorVerticalRelativeSizeDestination;
var DrawingAnchorRelativeSizeValueDestination = (function (_super) {
    tslib_1.__extends(DrawingAnchorRelativeSizeValueDestination, _super);
    function DrawingAnchorRelativeSizeValueDestination(data, positionDestination) {
        var _this = _super.call(this, data) || this;
        _this.sizeDestination = positionDestination;
        return _this;
    }
    DrawingAnchorRelativeSizeValueDestination.prototype.processText = function (reader) {
        var text = reader.value;
        if (!string_1.StringUtils.isNullOrEmpty(text))
            this.sizeDestination.value = this.data.readerHelper.getIntegerValueCore(text, 100 * 1000);
        return true;
    };
    return DrawingAnchorRelativeSizeValueDestination;
}(destination_1.LeafElementDestination));
exports.DrawingAnchorRelativeSizeValueDestination = DrawingAnchorRelativeSizeValueDestination;
